import heartIcon from "../assets/images/heart_logo_unity.png";
import { Link } from "react-router-dom";
const Assessments = () => {
  return (
    <div className="px-6 pt-8 lg:pb-20 md:pb-20 pb-10 relative z-50 responsive-assment">
      <div className="tab-screen">
        <div className="mb-3 flex flex-row items-center text-black responsive-top-heading relative">
          {/* Background Blur */}
          <div className="absolute inset-0 z-[0] flex justify-center">
            <div className="w-[80%] h-64 mt-7 blur-[90px] rounded-full bg-[#A7D4FF]/60"></div>
          </div>

          <div className="relative z-[10] py-8 w-full">
            <div className="bg-cardbg70 backdrop-blur-xl w-full p-6 rounded-3xl shadow-xl">
              <div className="flex justify-between items-start">
                <h1 className="text-[28px] font-bold leading-tight text-white">
                  Facial <br /> Biomarker <br /> Intelligence
                </h1>

                <img
                  src={heartIcon}
                  alt="Heart Icon"
                  className="w-[120px] object-contain"
                />
              </div>

              <p className="text-[#FFFF] font-light text-[15px] leading-relaxed mt-4">
                Facial Biomarker Intelligence is a non-contact, AI-powered
                digital health capability that analyzes facial signals to derive
                key physiological markers such as HR, RR, and PRQ, along with
                visual facial biomarkers like redness, dark circles, and eye
                bags. These insights are combined with environmental context
                (e.g., AQI) to deliver a quick, holistic snapshot of an
                individual’s health and wellness—without wearables or sensors.
              </p>

              <p className="text-[#FFFF] font-light text-[15px] leading-relaxed mt-4">
                It enables fast, scalable health screening and monitoring for
                preventive care, corporate wellness, insurance, and digital
                health platforms.
              </p>

              <Link
                to="/vital-scan-instructions"
                className="block w-full mt-6 p-3 rounded-xl bg-[#7591CD] text-white text-center font-medium"
              >
                Start Assessments
              </Link>
            </div>

            <div className="bg-[#364560] w-full p-5 rounded-2xl mt-8 text-xs text-white/70 leading-relaxed">
              <p className="text-white font-semibold mb-2">Disclaimer :</p>
              <p>
                For investigational use only. Careplix is not a substitute for
                the clinical judgment of a health care professional. Careplix is
                intended to improve your awareness of general wellness. Careplix
                does not diagnose, treat, mitigate or prevent any disease,
                symptom, disorder or abnormal physical state. Consult with a
                health care professional or emergency services if you believe
                you may have a medical issue.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assessments;
